<style lang="scss">
  @import '../resources/scss/news_page.scss';
</style>

<script lang="ts">
  import SkeletonTheme from '../../node_modules/svelte-skeleton-loader/src/Skeleton-theme.svelte'
  export let color = '#202020'
  export let highlightColor = '#444'
</script>

<SkeletonTheme {color} {highlightColor}>
  <slot name="skeleton-content" />
</SkeletonTheme>
